import { render, staticRenderFns } from "./publcMenuList.vue?vue&type=template&id=ef4118a0&"
import script from "./publcMenuList.vue?vue&type=script&lang=js&"
export * from "./publcMenuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports